import { render } from "./SpecialityDeleteModal.vue?vue&type=template&id=60f32b52"
import script from "./SpecialityDeleteModal.vue?vue&type=script&lang=js"
export * from "./SpecialityDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__